import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AboutComponents } from './aboutComponents';
import './App.css';
import { Footer, Header } from './components';
import { MasterComponents } from './mainComponents';
import { ContactComponents } from './contactComponent';
import { ProductComponent } from './productComponent';
import { useEffect } from 'react';

function ScrollHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollHandler />
      <Header />
      <Routes>
        <Route path="/" element={<MasterComponents />} />
        <Route path="/about" element={<AboutComponents />} />
        <Route path="/products" element={<ProductComponent/>}/>
        <Route path='/contact' element={<ContactComponents/>} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
